import { ApiError, ApiService } from "@touchtech/web-api-client";

const handleError = async (error: ApiError) => {
  throw error;
};

ApiService.initialize(handleError);

export default ApiService.instance.api;
